import * as Sentry from "@sentry/nextjs"
import axios from "axios"

export const downloadFile = (base64string: string, filename = "filename") => {
  const linkSource = base64string
  const downloadLink = document.createElement("a")
  const fileName = filename

  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}

export const processAxiosError = (err: unknown) => {
  Sentry.captureException(err)
  if (axios.isAxiosError(err)) {
    if (err.response) {
      // Request made but the server responded with an error
      console.log(err.response.data)
      console.log(err.response.status)
      console.log(err.response.headers)
    } else if (err.request) {
      // Request made but no response is received from the server.
      console.log(err.request)
    }
  } else {
    // Error occured while setting up the request
    console.log("Error", err)
  }
}
